// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  gameId: __t.u64().primaryKey().name("game_id"),
  creator: __t.identity(),
  worldId: __t.u64().name("world_id"),
  mode: __t.string(),
  pinnedTo: __t.u64().name("pinned_to"),
  pinned: __t.bool(),
  certified: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
});
